import React, {createElement, MouseEventHandler} from 'react';
import {isMobile} from 'react-device-detect';
import {useTranslation} from 'react-i18next';

import {ReactComponent as iconInfo} from '../../../assets/icons/lines/system-info.svg';
import {ReactComponent as iconGo} from '../../../assets/icons/lines/system-quieroir-1.svg';
import {ReactComponent as iconShare} from '../../../assets/icons/lines/system-share.svg';
import {ReactComponent as iconReport} from '../../../assets/icons/lines/systemReportar.svg';

import './button-section.scss';

interface ButtonSectionInterface {
    txtButtons: Array<string>,
    mapUrl?: string,
    redirectMoreInfo?: MouseEventHandler<HTMLButtonElement>,
    share?: MouseEventHandler<HTMLButtonElement>,
    report?: MouseEventHandler<HTMLButtonElement>,
    goToDirection?: MouseEventHandler<HTMLButtonElement>,
    slug?: string,
}

const slugLinks: { [key: string]: string } = {
    'busamb': 'A',
    'fgc': 'A',
    'metro': 'A',
    'renfe': 'A',
    'trambesos': 'A',
    'trambaix': 'A',
    'bicing': 'BICI',
    'bici': 'BICIBOX',
    'ambici': 'AMBBici',
    'taxi': 'PIC',
};

export default function ButtonSection({
    txtButtons = [],
    mapUrl,
    redirectMoreInfo = () => {
    },
    share = () => {
    },
    report = () => {
    },
    goToDirection = () => {
    },
    slug,
}: ButtonSectionInterface) {
    const {t} = useTranslation();

    const handleReportClick = () => {
        const linkBase = 'https://www.ambmobilitat.cat/Quejas/Quejas.aspx?Tipo=';
        const linkSuffix = slug && slugLinks[slug] ? slugLinks[slug] : 'O';
        const link = `${linkBase}${linkSuffix}`;
        window.open(link, '_blank');
    };

    const handleMapClick = async () => {
        try {
            if (!mapUrl) return;
            const response = await fetch(mapUrl);
            if (!response.ok) {
                throw new Error(`Error al descargar el archivo: ${response.statusText}`);
            }
            const blob = await response.blob();
            const fileName = mapUrl.split('/').pop() || 'downloaded_file.pdf';
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error('Error descargando el archivo:', error);
        }
    };


    const buttons = txtButtons.map((btn: string) => {
        let icon;
        let label;
        let onClickFunc;
        if (btn == 'info') {
            icon = iconInfo;
            label = t('translation:web_btn_more_info');
            onClickFunc = redirectMoreInfo;
        } else if (btn == 'share') {
            icon = iconShare;
            label = t('translation:transport_sheet_toolbar_share');
            onClickFunc = share;
        } else if (btn == 'report') {
            icon = iconReport;
            label = t('translation:transport_sheet_toolbar_report');
            onClickFunc = handleReportClick;
        } else if (btn == 'map') {
            icon = iconShare;
            label = t('translation:transport_sheet_toolbar_map_pdf');
            onClickFunc = handleMapClick;
        } else {
            icon = iconGo;
            label = t('translation:transport_sheet_toolbar_indications');
            onClickFunc = goToDirection;
        }

        return (
            <button
                key={btn}
                className={btn}
                onClick={onClickFunc}
            >
                {createElement(icon)}
                <span>{label}</span>
            </button>
        );
    });

    return (<>
        <div className={isMobile ? 'pin-buttons pin-buttons-mobile' : 'pin-buttons pin-buttons-dtp'}>
            {buttons}
        </div>
        <div className="separator separator-dsk"></div>
    </>);
}
